export const isAnyTextSelected = () => {
  const selection = window.getSelection()
  if (!selection || selection.type !== 'Range') return false

  return selection.toString().length > 0
}
